import { CellWithTooltip } from "@/components/data-table/CellWithTooltip";
import { ColumnHeader } from "@/components/data-table/ColumnHeader";
import { TypographyInlineCode } from "@/components/typography/InlineCode";
import { createColumnHelper } from "@tanstack/react-table";
import { MemberAction } from "./member-actions/MemberAction";
import { MemberTable } from "./types";

const columnHelper = createColumnHelper<MemberTable>();

export const memberColumns = [
  columnHelper.accessor("name", {
    cell: ({ cell }) => <CellWithTooltip cellValue={cell.getValue()} />,
    header: ({ column }) => <ColumnHeader column={column} title="Name" />
  }),
  columnHelper.accessor("role", {
    cell: (info) => (
      <TypographyInlineCode>
        {info.getValue().toLowerCase()}
      </TypographyInlineCode>
    ),
    header: ({ column }) => <ColumnHeader column={column} title="Role" />
  }),
  columnHelper.accessor("email", {
    cell: ({ cell }) => <CellWithTooltip cellValue={cell.getValue()} />,
    header: ({ column }) => <ColumnHeader column={column} title="Email" />
  }),
  columnHelper.display({
    id: "memberAction",
    cell: ({ cell }) => {
      return <MemberAction member={cell.row.original} />;
    }
  })
];
